import apiClient from '../apiClient'
import { WebTextNamespace } from './WebTextsNamespacesResponses'

/**
 * Get available webtext namespaces 
 * @param companyId - Optional company, null to get current company texts
 * @returns 
 */
export const getWebTextNamespaces = async (companyId: number | null): Promise<WebTextNamespace[]> =>
	await apiClient.get('/api/WebTextsNamespaces', { companyId })